<template lang="pug">
  .order.promotion
    .order__content#order-gap
      //.order-picture
        picture
          img(:src="promotion.promotion.imageUrl")
      .news__item-event#itemWidth
        div.wrapperImg
          div.eventImg.promoCard(:style="{ 'background-image': `url(${promotion.promotion.imageUrl})`}")
            .promo-card__header
            //.promo-card__discount.small(v-if="!promo.seoDescription.match(/сертификат/) && promo.bestDiscount !== 0") -{{promo.bestDiscount}}%
            p.promo-card__title.small {{ promotion.promotion.name }}
      .order-description#order-flex
        .order-title {{promotion.promotion.name}}
        //template(v-if="promotion.coupon")
          .line {{promotion.coupon.name}}
          .line Срок действия, до: {{promotion.coupon.endAt}}
        .line Код:&nbsp;
          span.semi-strong {{promotion.promocodeCode}}
        .line(v-html="promotion.promotion.shortDescription")
        //.desc-buttons
          router-link.btn(v-if="promotion.order.status == 0 && !promotion.order.paymentAt",
            :to="{name: 'payment', params: {id: promotion.order.id}}") Оплатить
          button.btn.button_primary-outline#btn-width(@click="toPromo(promotion.promotion)") Подробнее
    .order__status(v-if="promotion.coupon && promotion.coupon.endAt")
      .order-status.payed
        i
        | Доступно
      .order-msg Купон действителен до<br>{{promotion.coupon.endAt}}
    .order__status(v-else)
      .order-status.archive
        i
        | Архив
      .order-msg Купон не действителен
</template>

<script>
export default {
  props: ['promotion'],
  methods: {
    toPromo(promotion) {
      let isProd = false;
      if (process.browser && window) {
        isProd = window.location.href.match(/^https:\//);
      }
      window.open(`${isProd ? 'https://24skidki.by' : 'http://skidki.24.arcom.of.by'}/ru/minsk/${promotion.categoryId}/${promotion.id}`, '_blank');
    },
  },
};
</script>

<style lang="scss">
.order.promotion {
  .order__content{
    .order-picture{
      width: 240px;

      picture{
        img {
          min-width: 240px;
          min-height: 150px;
          max-width: 240px;
          max-height: 150px;
          border-radius: .125rem;
        }
      }
    }
  }
}
#itemWidth {
  width: unset;
}
</style>
